import { setCulture, loadCldr } from '@syncfusion/ej2-base';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as gregorianDE from 'cldr-data/main/de/ca-gregorian.json';
import * as numbersDE from 'cldr-data/main/de/numbers.json';
import * as timeZoneNamesDE from 'cldr-data/main/de/timeZoneNames.json';
import * as gregorianFR from 'cldr-data/main/fr/ca-gregorian.json';
import * as numbersFR from 'cldr-data/main/fr/numbers.json';
import * as timeZoneNamesFR from 'cldr-data/main/fr/timeZoneNames.json';
import * as gregorianIT from 'cldr-data/main/it/ca-gregorian.json';
import * as numbersIT from 'cldr-data/main/it/numbers.json';
import * as timeZoneNamesIT from 'cldr-data/main/it/timeZoneNames.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week

const datepickerFunctions = () => {
	const setLocale = (locale) => {
		setCulture(locale);
		switch (locale) {
			case 'de': 
				loadCldr(numberingSystems, gregorianDE, numbersDE, timeZoneNamesDE, weekData);
			break;
			case 'fr': 
				loadCldr(numberingSystems, gregorianFR, numbersFR, timeZoneNamesFR, weekData);
			break;
			case 'it': 
				loadCldr(numberingSystems, gregorianIT, numbersIT, timeZoneNamesIT, weekData);
			break;
		}
	}

	return {
		setLocale,
	}
};

export default datepickerFunctions;